export const RUTAS_GLOBALES = {
  login: 'login',
  logout: 'logout',
  sso: 'sso/:token',
  BackOffice: 'backoffice',
  BackOffice_Dashboard: 'backoffice/dashboard',
  BackOffice_AltaCliente: 'backoffice/cliente',
  BackOffice_GestionAltasClientes: 'backoffice/gestion-altas',
  BackOffice_GestionImportacion: 'backoffice/importacion',
  BackOffice_GestionImportarCatalogos: 'backoffice/importar-catalogos',
  BackOffice_GestionSaldoHermes: 'backoffice/saldo-hermes',
  sistemaSalud: 'sistemaSalud',
  sistemaSaludEditar: 'sistemaSalud/editar',
  sistemaSaludNuevo: 'sistemaSalud/nuevo',
  gruposClientes: 'clientes/gruposclientes',
  gruposClientes_Editar: 'clientes/gruposclientes/editar',
  motivoDevolucion: 'tienda/devolucion',
  motivoDevolucion_editar: 'tienda/devolucion/editar',
  motivoDevolucion_nuevo: 'tienda/devolucion/nuevo',
  dashboard: 'dashboard',
};
export type RutasGlobales = keyof typeof RUTAS_GLOBALES;
